import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import AviveStatuses from '../JurisdictionView/AviveAED/AviveStatuses';
import { formatPhone } from '../JurisdictionView/AviveAED/PhoneField';
import { normalizePhone } from '../JurisdictionView/AviveAED/aviveSlice';
import MapCard from '../Map/MapCard';
import { SpatialLayerCardContainer } from './MapCard.styles';

const DynamicLayerCard = () => {
  const mapCardData = useSelector(state => state.mapCard.mapCardData);

  /**
   * Dynamic layers have the `display_schema` as the `attributes`.
   */
  const getDisplaySchema = useCallback(() => {
    return mapCardData?.layerData?.attributes;
  }, [mapCardData]);

  const isAviveRequest = mapCardData?.layerData?.key === 'avive_aed_request';

  const renderAviveStatuses = () => {
    if (!isAviveRequest) {
      return null;
    }

    const phone = mapCardData?.spatialObject?.attributes?.phone_number;
    return <AviveStatuses phone={phone} pb={16} />;
  };

  let data = mapCardData?.spatialObject?.attributes;
  if (isAviveRequest) {
    data = {
      ...data,
      phone_number: formatPhone(normalizePhone(data?.phone_number), {
        onlyDashes: true,
      }),
    };
  }

  return (
    <SpatialLayerCardContainer>
      <MapCard
        data={data}
        displaySchema={getDisplaySchema()}
        objectData={mapCardData?.spatialObject}
        createdTime={mapCardData?.spatialObject?.date_created}
        layer={mapCardData?.layerData}
        title={mapCardData?.layerData.title}
        renderCustom={isAviveRequest ? renderAviveStatuses : () => null}
        isAviveRequest={isAviveRequest}
      />
    </SpatialLayerCardContainer>
  );
};

export default DynamicLayerCard;
